import VideoModal from './modules/_video-modal'
import { SmoothScroll } from './modules/_smooth-scroll'
import GravityFormsTracking from './modules/_gravity-forms-tracking'

document.addEventListener('DOMContentLoaded', () => {
  VideoModal()
  SmoothScroll()
  GravityFormsTracking()
})
